import React, { Component } from 'react';
import { connect } from 'react-redux';

import PeopleDirectoryContainer from './unityEmbeds/PeopleDirectory/PeopleDirectoryContainer';
import { eventSelector } from '../../selectors/EventSelectors';
import CommunityView from './CommunityView';

class MainCommunityContainerView extends Component {
    render() {
        const { event } = this.props;
        const isPeopleV2Community = event?.features?.communityVersion === 'PEOPLE_V2';

        return isPeopleV2Community ? (
            <PeopleDirectoryContainer />
        ) : (
            <CommunityView />
        );
    }
}

const mapStateToProps = (state) => ({
    event: eventSelector(state)
});

export default connect(mapStateToProps)(MainCommunityContainerView);
